import { React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";
import styles from "../styles/home.module.css";
import abrirWhatsApp from "../hooks/abrirWhatsapp";
import usePageTracking from "../components/pageTracking";
import ReactPixel from "react-facebook-pixel";

const Home = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const irParaCadastro = () => {
    navigate("/cadastro");
  };

  useEffect(() => {
    ReactPixel.pageView(); // Dispara evento de pageview
    ReactPixel.track("Home"); // Evento customizado, opcional
  }, []);

  usePageTracking();
  return (
    <div className="container-fluid tela-central text-center">
      <div className="text-center">
        <div className="logo-topo">
          <img className="mt-1" src="../img/iconwp.png" alt="" width="120px" />
        </div>
        <div className={`${styles.conteudo}`}>
          <div
            style={isMobile ? {} : { paddingLeft: "10%", paddingRight: "10%" }}
          >
            <h1 style={{ fontWeight: "bold" }}>
              Bem-vindo à Calculadora do Distrato!
            </h1>
            <br />
            <label className={`${styles.descricao}`}>
              Não caia na cilada de aceitar o que o empreendimento diz, você
              pode e deve buscar seus direitos e{" "}
              <b>reaver os valores pagos de uma forma justa.</b>
            </label>
            <br />
            <br />
            <label className={`${styles.descricao}`}>
              Veja gratuitamente uma estimativa dos valores a serem recebidos
              pela rescição do seu compromisso de compra e venda de terreno:
            </label>
            <br />
            <br />
            <button
              className={
                isMobile
                  ? "btn btn-primary borda-botao"
                  : "btn btn-primary btn-lg borda-botao"
              }
              style={{ width: "350px" }}
              onClick={irParaCadastro}
            >
              Acessar Calculadora
            </button>
            <button
              className={
                isMobile
                  ? "btn btn-secondary borda-botao"
                  : "btn btn-secondary btn-lg borda-botao"
              }
              style={{ width: "350px" }}
              onClick={abrirWhatsApp}
            >
              Atendimento Personalizado
            </button>
            <br />
            <br />
            <br />
            <label className="obs mb-3">
              Obs.: o resultado do cálculo é uma estimativa que não substitui
              uma análise aprofundada do caso concreto e das condições e
              peculiaridades do contrato em análise.
            </label>
          </div>
        </div>
      </div>

      {/* Elementos decorativos */}
      <div className="quadrado-preto" />
      <div className="quadrado-listrado" />
      <div className="quadrado-listrado-preto" />
    </div>
  );
};

export default Home;
